import { objectToQueryString } from "../helpers/ApiHelper";
import { ICarePerformer, ICarePerformerResponse, ICarePerformerSearchParams, ISaveCarePerformer } from "../models/ICarePerformer";
import { IUserListItem } from "../models/IUser";
import * as Utils from "../utils/Config";
import { ApiClient, IPaginatedResponse } from "./ApiClient";

export class CarePerformerApi extends ApiClient {

    searchCarePerformers(searchParams: ICarePerformerSearchParams, success: (data: IPaginatedResponse<ICarePerformerResponse>) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<ICarePerformerResponse>(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformers/searchCarePerformers?${queryString}`, success, undefined, final);
    }

    getCarePerformerById(carePerformerId: number, success: (data: ICarePerformer) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer>(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformers/${carePerformerId}`, success, error, final);
    }

    updateCarePerformer(data: ISaveCarePerformer, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.put(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformers`, data, success, error, final);
    }

    getCarePerformerUsersByOrganisationId(organisationId: number, success: (data: IUserListItem[]) => void, final?: () => void) {
        this.get<IUserListItem[]>(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformers/getCarePerformerUsersByOrganisationId/${organisationId}`, success, undefined, final);
    }

    createCarePerformer(data: ISaveCarePerformer, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformers`, data, success, error, final);
    }
}
